import * as modules from '@/app-bootstrapping/componentRegister'

/* eslint-disable global-require */
export function loadVueComponents(app) {
  for (const key in modules) {
    const component = modules[key]
    const name = key
    app.component(name, component)
  }
}
